<div class="w-100 d-flex justify-content-between py-6">
  <hr class="w-100">
  <h1 class="w-25 text-center" translate>search.lexique</h1>
  <hr class="w-100">
</div>
<div  class="card mb-5 w-50 mx-auto  content flex-row-fluid pt-4 ">
  <ng-container *ngFor="let lexique of data$ | async  results"> 
    <div  class="p-4 d-flex justify-content-between align-items-center bg-light " >
      <span *ngIf="getKeys(lexique?.highlights).includes('word')" class="fw-bold highlighted" [innerHTML]="sanitize(lexique.highlights.word)"></span>
      <span *ngIf="!getKeys(lexique?.highlights).includes('word')" class="fw-bold">{{lexique?.word}}</span>
    </div>
    <div class="p-4">
      <span *ngIf="getKeys(lexique?.highlights).includes('description')" class="highlighted" [innerHTML]="sanitize(lexique.highlights.description)"></span>
      <span *ngIf="!getKeys(lexique?.highlights).includes('description')" >{{lexique?.description}}</span>
    </div>
  </ng-container>
</div>